import { ILoginResult } from "../interfaces/authentication/login-result.model.interface";
import { IPortalUser } from "../interfaces/authentication/portal-user.model.interface";

export class LoginResult implements ILoginResult {
    public success: boolean;
    public result: string;
    public token: string;
    public user: IPortalUser | null;

  constructor(success: boolean, result: string = "", token: string = "", user: IPortalUser | null = null) {
        this.success = success;
        this.result = result;
        this.token = token;
        this.user = user;
    }
}
